<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M22.76 3.233c-1.094.27-.854.055-8.08 7.228l-6.855 6.805c-2.361 2.341-6.317 6.432-6.38 6.599-.047.124-.085.36-.085.525 0 .64.872 1.53 1.498 1.53.543 0 .826-.218 2.716-2.098l1.864-1.853.021 10.53c.021 10.494.022 10.53.186 10.75.091.122.264.295.386.386l.221.165h31.336l.221-.165c.122-.091.295-.264.386-.386.164-.22.165-.256.186-10.752l.021-10.531 1.859 1.848c1.022 1.016 1.982 1.91 2.132 1.986.581.293 1.37-.024 1.846-.744.258-.389.309-.784.156-1.191-.046-.124-1.472-1.629-3.168-3.345-3.678-3.722-2.019-2.064-9.987-9.977-7.225-7.175-7.037-7.007-8.163-7.301-.559-.145-1.748-.15-2.317-.009m1.76 3.001c.219.102 2.316 2.149 6.62 6.458l6.301 6.309-.021 10.919-.02 10.92-2.974.021-2.975.021-.03-4.301-.03-4.301-.206-.76c-.401-1.471-1.084-2.628-2.131-3.611-3.019-2.832-7.706-2.715-10.541.264-.811.853-1.325 1.684-1.676 2.715-.406 1.19-.437 1.613-.437 5.963v4.031l-2.98-.021-2.98-.021-.02-10.92-.021-10.919 6.301-6.309c4.304-4.309 6.401-6.356 6.62-6.458.176-.083.446-.15.6-.15.154 0 .424.067.6.15m.557 22.768c.258.068.689.238.956.378.63.33 1.537 1.237 1.867 1.867.482.919.498 1.092.499 5.573l.001 4.06h-8.96l.001-4.06c.001-3.338.023-4.151.122-4.573.351-1.488 1.674-2.839 3.179-3.244.563-.152 1.753-.152 2.335-.001" fill-rule="evenodd"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'Home',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 48 48',
    },
  },
};
</script>

<style scoped>
  
</style>